<template>
  <BottomSheet v-model="open" :title="t('promo.acts.birthdayTitle')" grip>
    <div class="bd-body">
      <input v-model="value" class="bd-input" type="date" :max="today" />
      <p class="bd-hint">{{ t('promo.acts.birthdayHint') }}</p>
      <button type="button" class="bd-confirm" :disabled="!valid || submitting" @click="onSubmit">
        {{ t('promo.acts.birthdayConfirm') }}
      </button>
    </div>
  </BottomSheet>
</template>

<script setup lang="ts">
import BottomSheet from '~/components/BottomSheet.vue'
import { isValidDate } from '~/utils/time'

const props = defineProps<{ submitting?: boolean }>()

const emit = defineEmits<{
  submit: [birthday: string]
}>()

const open = defineModel<boolean>({ default: false })

const { t } = useI18n()

const value = ref('')
/**
 * 生日上限 = 站点「今天」（生日由奖励域按站点业务日校验；站点时区未取到时退回设备日期）。
 * 纯日期串比较，不再用 UTC 日期（西半球玩家晚上会被卡掉「今天」）。打开时刷新。
 */
const { siteToday } = useSiteContext()
const today = ref(siteToday())

const valid = computed(() => isValidDate(value.value) && value.value <= today.value)

watch(open, v => {
  if (!v) return
  value.value = ''
  today.value = siteToday()
})

const onSubmit = () => {
  if (!valid.value || props.submitting) return
  emit('submit', value.value)
}
</script>

<style scoped lang="scss">
.bd-body {
  padding: 4px 2px 8px;
}

.bd-input {
  width: 100%;
  padding: 12px 14px;
  border-radius: var(--r-md);
  border: 1px solid var(--hairline);
  background: var(--surface2);
  color: var(--text);
  font-size: 15px;
  font-weight: 700;
}

.bd-hint {
  margin: 10px 2px 14px;
  font-size: 12px;
  line-height: 1.6;
  color: var(--muted);
}

.bd-confirm {
  width: 100%;
  padding: 12px 16px;
  border-radius: var(--r-md);
  background: var(--cta-go);
  color: #fff;
  font-size: 15px;
  font-weight: 800;

  &:disabled {
    background: var(--cta-wait-bg);
    color: rgb(255 255 255 / 68%);
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }
}
</style>
